import { IGranteePermissions } from '../models/IGranteePermissions';
import { IGetItemsParams } from '../ServerApi/types/IGetItemsParams';
import { ITypedIds } from '../ServerApi/types/ITypedIds';
import { EffectivePermissionsService } from '../services/EffectivePermissionsService';
import { IListFetcher } from './IListFetcher';
import { ListResult } from './ListResult';

export class EffectivePermissionsFetcher implements IListFetcher<IGranteePermissions> {

  private effectivePermissionsService: EffectivePermissionsService;
  private authorizables: ITypedIds;

  constructor(effectivePermissionsService: EffectivePermissionsService, authorizables: ITypedIds) {
    this.effectivePermissionsService = effectivePermissionsService;
    this.authorizables = authorizables;
  }

  public setAuthorizables(authorizables: ITypedIds) {
    this.authorizables = authorizables;
  }

  public fetchList(params: IGetItemsParams): ng.IPromise<ListResult<IGranteePermissions>> {
    return this.effectivePermissionsService.getEffectivePermissions(params, this.authorizables);
  }

}
